const AdminLoginPage = () => import ('./index.vue')
const AdminPasswordResetPage = () => import ('./_components/password_reset.vue')
const AdminPasswordOtp = () => import ('./_components/password_otp.vue')

export default [
    {
        path: '/login',
        component: AdminLoginPage,
        name: 'AdminLoginIndex'
    },
    {
        path: '/password/reset',
        component: AdminPasswordResetPage,
        name: 'AdminPasswordResetIndex'
    },
    {
        path: '/password/otp/:phone',
        component: AdminPasswordOtp,
        name: 'AdminPasswordOtpIndex'
    }
]